import React from "react";
import { connect } from "react-redux";
import { Link, NavLink } from "react-router-dom";
import { Dropdown, Header, Icon, Label, Menu, Responsive } from "semantic-ui-react";
import ReusableSidebar from "../../components/shared/ReusableSidebar";
import { startLogout } from "../../store/actions/shared/auth";
import { getTitleDecorator } from "../../utils/functionUtils";
import "./NavigationbarDesktop.css";
require("moment/locale/en-gb");

// Internal ExternalRoute that redirects to the Jira Service Desk portal (see AppRouters)
const REPORT_PROBLEM_PATH = "/avvale-support";
const KNOWLEDGE_BASE_URL = "https://avvale-support.atlassian.net/wiki/spaces/AVVALEAEP/pages/19595414/AEP+-+Knowledge+Base";

class NavigationbarDesktop extends React.Component {
  constructor(props) {
    super(props);
    var menuState = window.localStorage.getItem("TEP_menu");

    if (menuState === "navslide_closed") {
      this.state = {
        isOpen: false,
        visible: "visibile",
        sideBarClasses: "very thin icon",
        marginLeft: "marginlefting",
        marginRight: "marginrighting",
        navfixed: "",
        mobileMenu: true,
        activeIndex: props.activeIndex,
        hover: false
      };
    } else {
      this.state = {
        isOpen: false,
        visible: "visibile",
        sideBarClasses: "",
        marginLeft: "",
        marginRight: "",
        navfixed: "navslide open",
        mobileMenu: false,
        activeIndex: props.activeIndex
      };
    }
  }

  toggleVisibility = () => {
    if (this.state.sideBarClasses !== "") {
      window.localStorage.setItem("TEP_menu", "navslide_open");
      this.setState({
        visible: "visibile",
        sideBarClasses: "",
        marginLeft: "",
        marginRight: "",
        navfixed: "navslide open",
        mobileMenu: false
      });
    } else {
      window.localStorage.setItem("TEP_menu", "navslide_closed");
      this.setState({
        visible: "visibile",
        sideBarClasses: "very thin icon ",
        marginLeft: "marginlefting",
        marginRight: "marginrighting",
        navfixed: "",
        mobileMenu: true
      });
    }
  };

  hoverOn = () => {
    this.setState({ hover: true });
  };
  hoverOff = () => {
    this.setState({ hover: false });
  };

  render() {
    const {
      visible,
      sideBarClasses,
      marginLeft,
      navfixed,
      mobileMenu,
    } = this.state;

    let username = "";
    if (this.props.auth && this.props.auth.user) {
      username = this.props.auth.user.attributes.given_name + " " + this.props.auth.user.attributes.family_name;
    }

    return (
      <Responsive minWidth={550}>
        <ReusableSidebar
          visible={visible}
          classes={sideBarClasses}
          showMobileMenu={mobileMenu}
          activeIndex={this.state.activeIndex}
          logoSidebar={true}
          loading={this.props.loading}
        />
        <div className="pusher pushable">
          <div className="pusher">
            <div className={"nav-bar navwrap"}>
              <Menu
                style={{ borderRadius: 0, "background": '#f97743' }}
                className={
                  "navslide inverted " +
                  marginLeft
                }>
                <div
                  id="nav-icon1"
                  className={"item " + navfixed}
                  style={{ cursor: "pointer" }}
                  onClick={this.toggleVisibility}
                >
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
                <div className="item ">
                  <NavLink to="/">
                    <Header
                      as="h2"
                      inverted
                      style={{ color: "white", fontSize: "1.5em", fontWeight: "700" }}>
                      Avvale Enterprise Portal {getTitleDecorator(window.location.href)}
                    </Header>
                  </NavLink>
                </div>
                <Menu.Menu position='right'>
                  {/* AEP-10493: Help button split into "Report a problem" and "Knowledge Base" */}
                  <Dropdown
                    item
                    trigger={(
                      <Label className="navbar-help-label" circular>
                        HELP
                      </Label>
                    )}
                    pointing='top right'
                    icon="dropdown"
                    aria-label="Help menu"
                    style={{ padding: "1.2rem" }}
                  >
                    <Dropdown.Menu>
                      <Dropdown.Item
                        as={Link}
                        to={REPORT_PROBLEM_PATH}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <Icon name="bug" aria-hidden="true" />Report a problem
                      </Dropdown.Item>
                      <Dropdown.Item
                        as="a"
                        href={KNOWLEDGE_BASE_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <Icon name="book" aria-hidden="true" />Knowledge Base
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>

                  <Dropdown
                    item
                    trigger={(<span>{username} <Icon name="user" size="large" style={{ marginLeft: '1rem' }} /></span>)}
                    pointing='top right'
                    icon="dropdown"
                    style={{ padding: "1.2rem" }}
                  >
                    <Dropdown.Menu>
                      <Dropdown.Item onClick={this.props.logout}><Icon name="sign out" />Sign out</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </Menu.Menu>
              </Menu>
            </div>

            <div className={"body mainWrap navslide " + marginLeft}>
              {/*<PopupMessage/> */}
              {this.props.children}
            </div>
          </div>
        </div>
      </Responsive>
    );
  }
}

const mapStateToProps = (state, props) => {
  return { auth: state.authReducer };
};

const mapDispatchToProps = dispatch => {
  return {
    logout: () => dispatch(startLogout())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NavigationbarDesktop);
